import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks while preserving safe formatting
 * @param html - The HTML string to sanitize
 * @returns Sanitized HTML string safe for rendering
 */
export default function sanitizeHTML(html: string): string {
	if (!html || typeof html !== 'string') {
		return '';
	}

	return DOMPurify.sanitize(html);
}
